module.exports = __webpack_public_path__ + "img/kurand-anniversary.dd4e46af.jpg";